import React from "react";
import { StudentsProfile } from "../components/layout/StudentsProfile";
import { LoadingSpinner } from "../components/layout/LoadingSpinner";
import { DashBoardHeader } from "../components/layout/DashBoardHeader";
import { useStudentAuth } from "../context/StudentAuthContext";

const StudentsDashBoard = ()=>{
    const { student, authLoading, studentLogout, isAuthenticated } = useStudentAuth();
    // console.log("student",student);
    
    if(authLoading){
       return  <LoadingSpinner/>
    }

    if(!student){
        return(
            <div className="error-container">
        <h2>No user data available</h2>
        <p>Please try logging in again.</p>
      </div>
        )
    }
    return(
        <>
        <DashBoardHeader/>
        <StudentsProfile
         studentsData={student}
                onLogout={studentLogout}
        />

        </>
    )
}
export {StudentsDashBoard}